const cities = [
  {
    name: "Strasbourg",
    href: "/",
    description: "Réparation de fenêtre à Strasbourg — atelier 82 rue de Heidenberg.",
  },
  {
    name: "Haguenau",
    href: "/reparation-fenetre-haguenau",
    description: "Réparation de fenêtre à Haguenau dans le nord du Bas-Rhin.",
  },
  {
    name: "Schiltigheim",
    href: "/reparation-fenetre-schiltigheim",
    description: "Réparation de fenêtre à Schiltigheim, proche de Strasbourg.",
  },
  {
    name: "Illkirch-Graffenstaden",
    href: "/reparation-fenetre-illkirch-graffenstaden",
    description: "Réparation de fenêtre à Illkirch-Graffenstaden au sud de Strasbourg.",
  },
  {
    name: "Sélestat",
    href: "/reparation-fenetre-selestat",
    description: "Réparation de fenêtre à Sélestat dans le sud du Bas-Rhin.",
  },
  {
    name: "Bischheim",
    href: "/reparation-fenetre-bischheim",
    description: "Réparation de fenêtre à Bischheim, à la porte nord de Strasbourg.",
  },
  {
    name: "Lingolsheim",
    href: "/reparation-fenetre-lingolsheim",
    description: "Réparation de fenêtre à Lingolsheim, à l'ouest de Strasbourg.",
  },
  {
    name: "Bischwiller",
    href: "/reparation-fenetre-bischwiller",
    description: "Réparation de fenêtre à Bischwiller dans le nord du Bas-Rhin.",
  },
  {
    name: "Saverne",
    href: "/reparation-fenetre-saverne",
    description: "Réparation de fenêtre à Saverne, au pied des Vosges.",
  },
  {
    name: "Obernai",
    href: "/reparation-fenetre-obernai",
    description: "Réparation de fenêtre à Obernai dans le vignoble alsacien.",
  },
  {
    name: "Ostwald",
    href: "/reparation-fenetre-ostwald",
    description: "Réparation de fenêtre à Ostwald, au sud de Strasbourg.",
  },
  {
    name: "Hœnheim",
    href: "/reparation-fenetre-hoenheim",
    description: "Réparation de fenêtre à Hœnheim au nord de Strasbourg.",
  },
];

export default function CitiesGrid() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-plum-dark mb-4">
          Nos zones d&apos;intervention
        </h2>
        <p className="text-plum-dark text-base md:text-lg mb-10 max-w-2xl">
          Cliquez sur votre ville pour découvrir nos services de réparation de fenêtre près de chez vous.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cities.map((city) => (
            <a
              key={city.href}
              href={city.href}
              className="group block bg-white rounded-2xl border border-rose-100 p-5 md:p-6 hover:border-coral/40 transition-colors"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-xl bg-rose-50 flex items-center justify-center group-hover:bg-coral/10 transition-colors">
                  <i className="ri-map-pin-line text-plum text-lg" />
                </div>
                <h3 className="font-serif text-base md:text-lg font-semibold text-plum-dark">
                  {city.name}
                </h3>
              </div>
              <p className="text-plum-dark text-sm leading-relaxed mb-4">
                {city.description}
              </p>
              <span className="inline-flex items-center gap-1 text-coral text-sm font-medium">
                Voir la page
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}